import React, { FC } from 'react';
import { UitkSpacing, UitkSpacingHr } from 'uitk-react-spacing';
import { SectionFragment } from 'graphql/__generated__/types';
import SidebarSectionElements from './sidebar-section-elements';
import { UitkText } from 'uitk-react-text';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { SidebarBadge } from '../sidebar-button/sidebar-badge';
import { UitkBadgeSize } from 'uitk-react-badge';
import { UitkBadgeStandardTheme } from 'uitk-react-badge/dist/types';

interface SidebarSectionProps {
  section: SectionFragment;
  withBottomBorder?: boolean;
}

const SidebarSection: FC<SidebarSectionProps> = ({ section, withBottomBorder }) => {
  const { heading, navigationElements, icon, badge } = section;

  return (
    <>
      {heading && (
        <UitkSpacing
          padding={{ inlinestart: icon ? 'one' : 'two', blockend: 'two' }}
          margin={{ inlinestart: icon ? 'half' : 'unset' }}
        >
          <UitkLayoutFlex space="half">
            {icon && (
              <UitkLayoutFlexItem>
                <UitkIcon
                  description={icon.description}
                  name={icon.token}
                  id={icon.id}
                  theme="default"
                  title={icon.title}
                  size={UitkIconSize.EXTRA_SMALL}
                />
              </UitkLayoutFlexItem>
            )}
            <UitkLayoutFlexItem>
              <UitkText weight="medium">
                {heading}
                {badge ? (
                  <SidebarBadge
                    text={badge.text}
                    size={badge.size as UitkBadgeSize}
                    theme={badge.theme as UitkBadgeStandardTheme}
                  />
                ) : null}
              </UitkText>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkSpacing>
      )}
      <SidebarSectionElements navigationElements={navigationElements} />
      {withBottomBorder && (
        <UitkSpacing padding={{ large: { inlinestart: 'two' } }}>
          <div>
            <UitkSpacingHr />
          </div>
        </UitkSpacing>
      )}
    </>
  );
};

export default SidebarSection;
